import { lazy } from 'react';
import { loadWithRetry } from '@Sage/ssm-utils';

export class OptionalChunkLoadError extends Error {
    constructor(error) {
        super(error?.message || 'Failed to load optional chunk');
        this.name = 'OptionalChunkLoadError';
        this.originalError = error;
    }
}

export const isOptionalChunkLoadError = (error) => error instanceof OptionalChunkLoadError;

export { loadWithRetry };

/**
 * Lazy loader for UI the application can run without. Failures are tagged so
 * OptionalLazyBoundary can drop the feature instead of escalating to the app boundary.
 * Uses blind retry (any failure) — optional UI can afford waiting on stale hashes.
 */
export const lazyOptional = (load, options = {}) =>
    lazy(() =>
        loadWithRetry(load, { shouldRetry: () => true, ...options }).catch((error) => {
            throw new OptionalChunkLoadError(error);
        }),
    );
